import { DisplayFromFHIR, getStringFromFHIR } from './ResourceFunctions';
import ResourceBottomDisplay from './ResourceBottomDisplay';

const DocumentReferenceDisplay = ({ fhirJson, classificationsArrayState, classificationsLoadedState }) => {

  let displayTitle;
  if (Array.isArray(fhirJson.extension)) {
    for (let extension of fhirJson.extension) {
      if (extension.url === 'http://hl7.org/fhir/StructureDefinition/artifact-title') {
        if (extension.valueString) {
          displayTitle = extension.valueString;
        }
      }
    }
  }
  if (fhirJson.title) {
    displayTitle = fhirJson.title;
  }

  return <div>
<div style={{ marginTop: "12px" }}>
    <h3 id="content">Content</h3>
      <div style={{ marginLeft: "24px" }}>
{displayTitle && <p><b>Title: </b>{displayTitle}</p>}
{fhirJson.type && <p><b>Type: </b>{getStringFromFHIR.CodeableConcept(fhirJson.type)}</p>}
{(Array.isArray(fhirJson.content) && fhirJson.content.length) && fhirJson.content.map((content, index) => {
  return <div key={index}><DisplayFromFHIR attachment={content.attachment}/></div>
})}
        {fhirJson.status && <p><b>Resource status: </b>{fhirJson.status}</p>}
        {fhirJson.docStatus && <p><b>Document status: </b>{fhirJson.docStatus}</p>}
      </div>
    <h3 id="description">Description</h3>
    <div style={{ marginLeft: "24px" }}>
        {fhirJson.description && <div><b>Description: </b><DisplayFromFHIR markdown={fhirJson.description} /></div>}
            {(fhirJson.category?.length > 1) && fhirJson.category.map((category, identifierIndex) => {
          return <div key={identifierIndex}><p><b>Category: </b>{getStringFromFHIR.CodeableConcept(category)}</p></div>
        })}
    </div>
    <h3 id="identification">Identification</h3>
    <div style={{ marginLeft: "24px" }}>     
            {(fhirJson.identifier?.length > 1) && fhirJson.identifier.map((identifier, identifierIndex) => {
          return <div key={identifierIndex}><p><b>Identifier: </b>{getStringFromFHIR.Identifier(identifier)}</p></div>
        })}
        {fhirJson.version && <p><b>Version: </b>{fhirJson.version}</p>}
    </div>
    <h3 id="subject">Subject</h3>
    <div style={{ marginLeft: "24px" }}>
        {fhirJson.subject && <div><b>Subject: </b><DisplayFromFHIR reference={fhirJson.subject} /></div>}
            {(fhirJson.related?.length > 1) && fhirJson.related.map((related, relatedIndex) => {
          return <div key={relatedIndex}><div><b>Related Item: </b><DisplayFromFHIR reference={related} /></div></div>
        })}
    </div>
    <h3 id="stewardship">Stewardship</h3>
    <div style={{ marginLeft: "24px" }}>
        {(fhirJson.author?.length > 1) && fhirJson.author.map((author, authorIndex) => {
          return <div key={authorIndex}><div><b>Author: </b><DisplayFromFHIR reference={author} /></div></div>
        })}
        {fhirJson.custodian && <div><b>Custodian: </b><DisplayFromFHIR reference={fhirJson.custodian} /></div>}
    </div>
  </div>
    <div style={{ marginTop: "12px" }}>
      <ResourceBottomDisplay howToCite="Citation not expected." fhirJson={fhirJson}
        classificationsLoadedState={classificationsLoadedState} classificationsArray={classificationsArrayState}
      />
    </div>
  </div>
}

export default DocumentReferenceDisplay;